import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useMilitaryPreciousMetalsLogic } from './hooks/useMilitaryPreciousMetalsLogic';
import { MilitaryPreciousMetalsForm } from './MilitaryPreciousMetalsForm';

export const EddMilitaryPreciousMetals = () => {
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useMilitaryPreciousMetalsLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={tCommon('sectionTitles.businessActivity')}
        headingContainerCustomStyle='!mb-[16px]'>
        <MilitaryPreciousMetalsForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
